"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ardea": {
    "d9337bbd": [{
      "hkey": "e83c3173",
      "slug": "marina-di-ardea",
      "name": "Marina di Ardea",
      "primary": true,
      "skipSearch": false
    }],
    "ardea-marina": [{
      "hkey": "e83c3173",
      "slug": "marina-di-ardea",
      "name": "Marina di Ardea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "eddfcf2e": [{
      "hkey": "199e73d6",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "ardea-paese": [{
      "hkey": "199e73d6",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "91c7a4bf": [{
      "hkey": "5a404744",
      "slug": "lido-dei-pini-di-ardea-lupetta",
      "name": "Lido dei Pini di Ardea-Lupetta",
      "primary": true,
      "skipSearch": false
    }],
    "lido-dei-pini-di-ardea": [{
      "hkey": "5a404744",
      "slug": "lido-dei-pini-di-ardea-lupetta",
      "name": "Lido dei Pini di Ardea-Lupetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "450120a3": [{
      "hkey": "de8188c1",
      "slug": "nuova-california-tor-san-lorenzo",
      "name": "Nuova California-Tor San Lorenzo",
      "primary": true,
      "skipSearch": false
    }],
    "nuova-california": [{
      "hkey": "de8188c1",
      "slug": "nuova-california-tor-san-lorenzo",
      "name": "Nuova California-Tor San Lorenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ardea"
    }],
    "4bd79387": [{
      "hkey": "42784193",
      "slug": "castagnetta-strampelli",
      "name": "Castagnetta-Strampelli",
      "primary": true,
      "skipSearch": false
    }],
    "strampelli-banditella-castagnetta": [{
      "hkey": "42784193",
      "slug": "castagnetta-strampelli",
      "name": "Castagnetta-Strampelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "312952d0": [{
      "hkey": "de8188c1",
      "slug": "nuova-california-tor-san-lorenzo",
      "name": "Nuova California-Tor San Lorenzo",
      "primary": true,
      "skipSearch": false
    }],
    "tor-san-lorenzo": [{
      "hkey": "de8188c1",
      "slug": "nuova-california-tor-san-lorenzo",
      "name": "Nuova California-Tor San Lorenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;